const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  role: state => state.user.role,
  privilege: state => state.user.privilege,
  routes: state => state.permission.routes,
  dash: state => state.work.dash,
  chan: state => state.work.chan
}
export default getters
